import { createSlice } from '@reduxjs/toolkit';

type InitialState = {
  type: string;
  plan: number;
  members: number | null;
  plans: any | null;
  ends_at: string;
};

const initialState: InitialState = {
  type: '',
  plan: 0,
  members: null,
  plans: null,
  ends_at: '',
};

const planSlice = createSlice({
  name: 'selected plan',
  initialState,
  reducers: {
    setSelectedPlan: (state, { payload }) => {
      const { type, id, ends_at }: { type: string; id: number; ends_at: string } = payload;

      state.type = type;
      state.plan = id;
      state.ends_at = ends_at;
    },
    setSelectedPlanId: (state, { payload }) => {
      const { id }: { id: number } = payload;

      state.plan = id;
    },
    setMembers: (state, { payload }) => {
      state.members = payload;
    },
    setPlans: (state, { payload }) => {
      state.plans = payload;
    },
  },
});

export const { setSelectedPlan, setSelectedPlanId, setMembers, setPlans } = planSlice.actions;

export default planSlice.reducer;
